import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons'
import DOMPurify from 'dompurify'
import { marked } from 'marked'
import { type ReactElement, useMemo } from 'react'
import { StandardModal } from '~/components/Global/Design/Modal/StandardModal'
import type { GlobalMessage } from '../../types'
import { markdownContent } from './GlobalMessageModal.css'

type GlobalMessageModalProps = {
  message: GlobalMessage
  description: string
  open: boolean
  onClose: () => void
}

export const GlobalMessageModal = ({
  message,
  description,
  open,
  onClose
}: GlobalMessageModalProps): ReactElement => {
  const html = useMemo(
    () => DOMPurify.sanitize(marked.parse(description, { async: false })),
    [description]
  )

  return (
    <StandardModal
      open={open}
      onClose={onClose}
      title={message.message}
      icon={faTriangleExclamation}
      fixedWidth
    >
      <div
        className={markdownContent}
        // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitized by DOMPurify
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </StandardModal>
  )
}
